import { formatServerUtcToLocal } from '../date/serverUtcToLocal';

type IsoInput = {
  iso?: string | number | Date;
  tsSeconds?: string | number;
};

export function formatJpnDate({ iso, tsSeconds }: IsoInput): string {
  if (tsSeconds != null) {
    return formatServerUtcToLocal(tsSeconds, {
      numberUnit: 'seconds',
      options: { timeZone: 'Asia/Tokyo' },
    });
  }

  return formatServerUtcToLocal(iso, {
    options: { timeZone: 'Asia/Tokyo' },
  });
}
